/* tslint:disable object-literal-key-quotes */

import * as Preact from 'preact'
import { Link } from 'preact-router/match'
import format from 'date-fns/format'
import locale from 'date-fns/locale/nb'
import { bem } from '@nrk/dh-utils'

import { Flag } from '../../Flag'
import * as styles from './index.css'

import { IMatch, INames, IMatchTeam, IResult } from '../../../../types'
import { formatResult } from '../helpers'
import { Result } from '../../../../center/components/common/Stemning/lib/components/Result/Result'

const { h } = Preact

interface IProps {
  isExternal?: boolean
  isNext: boolean
  match: IMatch
  BASE_URL: string
  active: boolean
}

export const MatchLink = ({
  BASE_URL,
  isExternal,
  isNext,
  match,
  active
}: IProps) => {
  try {
    const { teams, id, status, result } = match
    const href = `${BASE_URL}/kamp/?id=${id}`
    const playing = status === 'Pågår'
    const ended =
      status === 'Slutt' || status === 'Avbrutt' || status === 'Utsatt'
    const children = (
      <div role="text">
        <div class={styles['match-link__teams']}>
          <Team team={teams[0]} winner={result.winner} />
          <Team team={teams[1]} winner={result.winner} isRight={true} />
        </div>
        <Info match={match} />
      </div>
    )

    if (isExternal) {
      return (
        <a
          class={bem(styles['match-link'], { active, playing, ended })}
          href={href}
          id={isNext ? 'neste-kamp' : undefined}
        >
          {children}
        </a>
      )
    }

    return (
      <Link
        activeClassName=""
        class={bem(styles['match-link'], { active, playing, ended })}
        href={href}
        id={isNext ? 'neste-kamp' : undefined}
      >
        {children}
      </Link>
    )
  } catch (err) {
    return null
  }
}

interface ITeamProps {
  team: IMatchTeam
  isRight?: boolean
  winner?: 'home' | 'away' | null
}

const Team = ({ team, isRight = false, winner }: ITeamProps) => {
  const { names, type } = team

  if (!names) {
    return null
  }

  const isWinner = winner && type === winner

  return (
    <div class={bem(styles['match-link__team'], { right: isRight })}>
      <div class={styles['match-link__flag-wrapper']} aria-hidden>
        <Flag class={styles['match-link__flag']} names={names} />
      </div>
      <div class="nrk-sr">{`${names.full}${
        isWinner ? ' (vinner av straffesparkkonkurranse)' : ''
      }`}</div>

      {winner ? (
        <div aria-hidden>
          {names.short}
          {isWinner ? '*' : ''}
        </div>
      ) : (
        <div aria-hidden>{names.short}</div>
      )}
    </div>
  )
}

interface IInfoProps {
  match: IMatch
}

const CHANNELS = {
  NRK1: 'NRK',
  NRK2: 'NRK',
  NRK3: 'NRK',
  'TV 2 Sportskanalen': 'TV 2'
}
function formatShortChannel(channel: string) {
  return CHANNELS[channel] || channel
}

const Info = (props: IInfoProps) => {
  try {
    const { result, startDate, status, channel } = props.match
    const time = format(startDate, 'H:mm', { locale })

    let children

    switch (status) {
      case 'Pågår':
        children = (
          <div>
            <div class={styles['match-link__score']}>
              {formatResult(result)}
            </div>
            <div class={styles['match-link__pulse']} />
          </div>
        )
        break

      case 'IkkeStartet':
        children = (
          <div>
            <div class={styles['match-link__time']}>{time}</div>
            <div class={styles['match-link__channel']}>
              {formatShortChannel(channel)}
            </div>
          </div>
        )
        break

      default:
        children = (
          <div>
            <div class={styles['match-link__score']}>
              {formatResult(result)}
            </div>
            <div class={styles['match-link__status']}>{status}</div>
          </div>
        )
        break
    }

    return <div class={styles['match-link__info']}>{children}</div>
  } catch (err) {
    return null
  }
}
